export const login = {
    login: 'LOG IN',
    username: {
        name: 'Username',
        placeholder: 'Username',
        required: 'Please enter Username',
        too_short: '',
        invalid: '',
    },
    password: {
        name: 'Password',
        placeholder: 'Password',
        required: 'Please enter Password',
        too_short: '',
        invalid: '',
    },
    forget_password: 'Forget Password ?',
    err_login: {
        title: 'Invalid Username or Password, Please check the accuracy.',
    }
}
